import { Button } from 'components/ui/button';
import { useModal } from 'modules/modals/ModalProvider';
import { useBulkCreateReferencesMutation } from 'modules/threads/threadsApi';
import { BulkCreateReferencePayload } from 'modules/threads/types';
import { toast } from 'sonner';

export const useMultiFileUpload = (threadId: string) => {
  const { open } = useModal();
  const [createReferences] = useBulkCreateReferencesMutation();

  const openModal = () => {
    toast.dismiss();
    open({
      contentLabel: 'add files and links',
      variant: 'fullRight',
      name: 'Add Files and Links',
      modal: 'addReference',
      id: 'modal-add-reference',
      context: { threadId },
    });
  };

  const upload = async (payload: BulkCreateReferencePayload[]) => {
    const loadingToast = toast.loading('Uploading files...');

    try {
      const { succeeded, failed } = await createReferences(payload).unwrap();

      if (failed.length === 0) {
        toast.success('Files uploaded successfully', { id: loadingToast });
      } else if (succeeded.length === 0) {
        toast.error('An error occured. Failed to upload any files', {
          id: loadingToast,
          action: (
            <Button size="sm" variant="outline" onClick={openModal}>
              Try Again
            </Button>
          ),
        });
      } else {
        toast.warning('Some files were not uploaded', {
          description: `${failed.join(', ')} failed to upload`,
          id: loadingToast,
          action: (
            <Button size="sm" variant="outline" onClick={openModal}>
              Try Again
            </Button>
          ),
        });
      }
    } catch (err) {
      console.error(err);
      toast.error('An error occured. Failed to upload any files', { id: loadingToast });
    }
  };

  return { upload };
};
